<template>
    <div id="hello">


        <div id="content">
            <h1 id="main-title">

                <span>MIESZKANIA</span>
            </h1>


            <section>
                <div class="container  is-fluid">
                    <div class="columns  ">
                        <div class="column">

               <p style="font-size: 1.3em; line-height: 1.3em;">
                <br>
                Informacja dotycząca dostępności lokali mieszkalnych i usługowych, w szczególności informacje o sprzedaży lub rezerwacji udzielane są pod nr telefonu <strong><a href="tel:817108027">81 710 80 27</a></strong> oraz w biurze sprzedaży <strong>przy ul. Jutrzenki 3/70</strong> w Lublinie.
                <br><br>
                    <strong>Wizualizacje mają jedynie charakter poglądowy (mogą wyglądać inaczej niż w rzeczywistości) i nie stanowią oferty handlowej w rozumieniu art. 66 §1 Kodeksu Cywilnego.</strong>
                </p>
                <p>Budynek znajdujący na wizualizacjach obok prezentowanej inwestycji istnieje - nie jest to kolejny etap przedsięwzięcia deweloperskiego</p>
                <br><br><br>
                </div>
                </div>
                </div>


            </section>

            <section class="section no-padding-top">
            <div class="container  is-fluid"  id="localList">
                <div class="columns">
                    <div class="column is-full">
                        </div>
                        </div>
                        </div>
                        </section>

            <section class="section no-padding-top">
            <div class="container  is-fluid"  id="localList">
                <div class="columns">
                    <div class="column is-full">
                        <div class="filters">

                        <div class="columns">
                        <div class="column is-quarter"> 
                             <p class="has-text-centered">Piętro:
                            <span style="max-width: 500px; display: block; margin: auto; text-align: center;">
                                <v-select :options="localLevels" v-model="chosenLevel" :class="{active : chosenLevel}" :reduce="option => option.level" :searchable="false"></v-select>
                            </span>

                        </p>
                    </div>
                            <div class="column is-quarter"> 
                        <p class="has-text-centered">Rodzaj mieszkania:
                            <span style="max-width: 500px; display: block; margin: auto; text-align: center;">
                            <v-select :options="localRooms" v-model="chosenRooms" :class="{active : chosenRooms}" :reduce="option => option.pokoje" :searchable="false"></v-select>
                            </span>

                        </p>
                        </div>
             
                        <div class="column is-quarter"> 
                            <p class="has-text-centered">Numer:
                                <span style="max-width: 500px; display: block; margin: auto; text-align: center;">
                            <v-select :options="localNumbers" v-model="chosenLocal" :class="{active : chosenLocal}" :reduce="option => option.numer" :searchable="false"></v-select>
                            </span>

                            </p>
                        </div>


                            <div class="column is-quarter"> 
  <p class="has-text-centered">Status:
    <span style="max-width: 500px; display: block; margin: auto; text-align: center;">
      <v-select :options="localStatuses"
                v-model="chosenStatus"
                :class="{ active: chosenStatus }"
                :reduce="option => option.status"
                :searchable="false" />
    </span>
  </p>
</div>
                            </div>

                            <div class="column is-full"> 
                        <p class="has-text-centered">
                            Powierzchnia od: <input type="text" v-model="minArea" class="input fromto"  :class="{active : minArea}">&nbsp;m<sup>2</sup> do: <input type="text" v-model="maxArea" class="input fromto"   :class="{active : maxArea}">&nbsp;m<sup>2</sup>
                        </p>
                        </div>
                        </div>

                        <p>
                            <a @click="reset()" id="reset-btn" :class="{active : (chosenLocal || chosenDirection ||chosenRooms || chosenLevel ||  minArea || maxArea)}">wyczyść filtry</a>
                        </p>
                        <h2>KATALOG MIESZKAŃ</h2>
                        <div class="table-wrapper">
                        <table class="table is-striped" id="loc-table">
                            <tr>
                                <th>Budynek</th>
                                <th>Piętro</th>
                                <th>Nr</th>
                                <th>Metraż</th>
                                <th>Ilość Pokoi</th>
                                <th>Strona</th>
                                <th>Balkon</th>
                                <th>Taras</th>
                                <th>Ogródek</th>
                                <th>Karta Lokalu</th>
                                <th>Status</th>


                            </tr>
                            <tbody>
                            <tr v-for="(local, i) in processedLocals" :key="i" :style="{ opacity: local.status === 'sprzedane' ? 0.2 : 1 }">
                                <td ><div >
                                    <span v-html="$options.filters.subtext(local.czesc)"></span></div></td>
                                <td><div >
                                    <span v-html="$options.filters.subtext(local.pietro)"></span></div></td>
                                <td>{{local.numer}}</td>
                                <td><span v-html="$options.filters.metrify(local.metraz)"></span></td>
                                <td>{{local.pokoje}}</td>
                                <td><span v-html="local.strona"></span></td>
                                <td><span v-html="$options.filters.metrify(local.balkon)"></span></td>
                                <td><span v-html="$options.filters.metrify(local.taras)"></span></td>
                                <td><span v-html="$options.filters.metrify(local.ogrodek)"></span></td>
                                <td><a  v-if="local.status != 'sprzedane'" :href="'__mieszkania__/2024.06.24 Kaczeńcowa karty mieszkań_4-' +  local.numer.replace('M.', 'M') + '.pdf?ver=1'">Pobierz</a></td>
                                <td><span  v-if="local.status" v-html="local.status"></span></td>
                               

                            </tr>
                            <tr v-if="!(filteredLocals.length > 0)">
                                <td colspan="8">Nie znaleziono mieszkań o podanych parametrach.</td>
                            </tr>
                            </tbody>

                        </table>
                        </div>
                    </div>

                </div>

            </div>
        </section>





        </div>










    </div>
</template>

<script>
    //import Render from "../components/Render";
    //import Render1 from "../components/Render1";
    //import Flatplan from "../components/Flatplan";
    import isSame from '../assets/js/common.js';
    import anime from "animejs";
    import Vue from 'vue';
    import vSelect from 'vue-select';
    Vue.component('v-select', vSelect);
    import 'vue-select/dist/vue-select.css';
    import uniqBy from 'lodash/uniqBy';
    import sortBy from 'lodash/sortBy';
    import axios from 'axios';


    var levels = [];
    levels[0] = 'PARTER';
    levels[1] = 'I PIĘTRO';
    levels[2] = 'II PIĘTRO';
    levels[3] = 'III PIĘTRO';
    levels[4] = 'IV PIĘTRO';
    levels[4] = 'V PIĘTRO';


    var transforms = [];
    transforms['PARTER'] = 'PARTER_25072022';
    transforms['I PIĘTRO'] = '27072022_PIĘTRO I';
    transforms['II PIĘTRO'] = '29072022_PIĘTRO II';
    transforms['III PIĘTRO'] = 'Piętro III_01082022';


    var minuses = [];
    minuses['PARTER'] = 0;
    minuses['I PIĘTRO'] = 10;
    minuses['II PIĘTRO'] = 20;
    minuses['III PIĘTRO'] = 30;
    minuses['IV PIĘTRO'] = 40;



    export default {
        name: 'Flats',
        data() {
            return {
                isDay: false,
                chosenLevel: this.$route.params.chosenLevel ? this.$route.params.chosenLevel : "",
                chosenRooms: "",
                chosenLocal: "",
                chosenDirection: "",
                chosenStatus: "",
                minArea: "",
                maxArea: "",
                transforms: transforms,
                minuses: minuses,
                locals: []
            }
        },
        props: {
            msg: String
        },

        created() {
            if(this.$route.params.chosenLevel) {
                this.chosenLevel = levels[this.$route.params.chosenLevel];
            }
            // Fetch the locals data from the JSON file
            this.fetchLocalsData();
        },

        methods: {
            fetchLocalsData() {
                const timestamp = new Date().getTime();
                axios.get(`/data/locals.json?t=${timestamp}`)
                    .then(response => {
                        this.locals = response.data.locals;
                    })
                    .catch(error => {
                        console.error('Error loading locals data:', error);
                    });
            },
            redirect(route) {
                this.$router.push(route);
            },

            chooseLevel(number) {
                this.chosenLevel = levels[number];
                this.chosenLocal = '';
                console.log(number);
                this.scroll({
                    to: '#flatplan'
                });
            },
            chooseLocal(number) {
                this.chosenLocal = number;
                this.chosenRooms = '';
                this.scroll({
                    to: '#localList'
                });
            },


            reset() {
                this.chosenLocal = "";
                this.chosenLevel = "";
                this.minArea = "";
                this.maxArea = "";
                this.chosenRooms = "";
                this.chosenStatus = "";
            },


            isSame: isSame,

            scroll(arg) {
                let el = document.querySelector(arg.to),
                    offset = parseInt(arg.offset) || 0,
                    duration = arg.duration || 800,
                    easing = arg.easing || 'easeOutExpo',
                    callback = arg.callback || null;

                if ( el ) {
                    anime({
                        targets: ['html', 'body'],
                        scrollTop: (el.offsetTop - offset),
                        duration: duration,
                        easing: easing,
                        complete: callback
                    })
                        .finished.then(() => {

                    });
                }
            },


            applyRowspanToMultipleColumns(tableID, columnIndices) {
                const table = document.getElementById(tableID);
                const lastValues = {};
                const valueCounts = {};
                const toRowspan = {};

                for (let rowIndex = 0; rowIndex < table.rows.length; rowIndex++) {
                    const row = table.rows[rowIndex];
                    let removed = 0;

                    for (let columnIndex of columnIndices) {
                    const adjustedColumnIndex = columnIndex - removed;
                    const cell = row.cells[adjustedColumnIndex];

                    if (cell) {
                        const value = cell.textContent || cell.innerText;

                        if (value === lastValues[columnIndex]) {
                        valueCounts[columnIndex]++;
                        cell.remove();
                        removed++;
                        toRowspan[columnIndex].rowSpan = valueCounts[columnIndex];
                        } else {
                        lastValues[columnIndex] = value;
                        valueCounts[columnIndex] = 1;
                        toRowspan[columnIndex] = cell;
                        }
                    }
                }
            }
            }

        },
        filters: {
            metrify : function (value) {
                if (!value) { return '&ndash;'; }

                return value + '&nbsp;m<sup>2</sup>';
            },

            subtext : function (value) {
                return value.replace("(PODDASZE)", '<span class="subtext">(PODDASZE)</span>');
            }

        },
        computed: {
            filteredLocals : function() {
                var locals = this.locals;

                if (this.chosenStatus) {
                    const chosenStatus = this.chosenStatus;

                    if (chosenStatus === '__wolne__') {
                        locals = locals.filter(local => !local.status || local.status.trim() === '');
                    } else {
                        locals = locals.filter(local => local.status === chosenStatus);
                    }
                }
                if(this.chosenLevel) {
                    var chosenLevel = this.chosenLevel;
                    locals = locals.filter(function(local){
                        return local.pietro == chosenLevel;
                    });
                }

                if(this.chosenRooms) {
                    var chosenRooms = this.chosenRooms;
                    locals = locals.filter(function(local){
                        return local.pokoje == chosenRooms;
                    });
                }

                if(this.minArea) {
                    var minArea = this.minArea;
                    locals = locals.filter(function(local){
                        return  Number(local.metraz.replace(/,/g, '.')) >= Number(minArea.replace(/,/g, '.'));
                    });
                }

                if(this.maxArea) {
                    var maxArea = this.maxArea;
                    locals = locals.filter(function(local){
                        return Number(local.metraz.replace(/,/g, '.')) <= Number(maxArea.replace(/,/g, '.'));
                    });
                }

                if(this.chosenLocal) {
                    var chosenLocal = this.chosenLocal;
                    locals = locals.filter(function(local){
                        return local.numer.toString() === chosenLocal.toString();
                    });
                }

                if(this.chosenDirection) {
                    var chosenDirection = this.chosenDirection;
                    locals = locals.filter(function(local){
                        return local.strona == chosenDirection;
                    });
                }


                return locals;
            },

            processedLocals: function () {
                var locals = this.filteredLocals;
                locals = locals.map(function(local) {
                    var level = local.pietro;
                    var filtered = locals.filter(function(local){
                        return local.pietro === level;
                    });
                    local.count = filtered.length;
                    return local;
                });

                return locals;
            },

            localLevels: function() {
                return  [{"level": '', "label" : "WSZYSTKIE"}].concat(uniqBy(this.locals.map(local => ({ "level" : local.pietro , "label" : local.pietro })), 'level'));

            },
            localRooms: function() {
                return  [{"pokoje": '', "label" : "WSZYSTKIE"}].concat(sortBy(uniqBy(this.locals.map(local => ({ "pokoje" : local.pokoje , "label" : local.pokoje })), 'pokoje'), ['pokoje']));
            },
            localNumbers: function() {
                return  [{"numer": '', "label" : "WSZYSTKIE"}].concat(uniqBy(this.locals.map(local => ({ "numer" : local.numer , "label" : local.numer })), 'numer'));
            },
            localDirections: function() {
                return  [{"strona": '', "label" : "WSZYSTKIE"}].concat(uniqBy(this.locals.map(local => ({ "strona" : local.strona , "label" : local.strona })), 'strona'));
            },
            localStatuses() {
                const uniqueStatuses = uniqBy(
                    this.locals
                        .filter(local => local.status) // only those with non-empty status
                        .map(local => ({ status: local.status, label: local.status })),
                    'status'
                );

                return [
                    { status: '', label: 'WSZYSTKIE' },
                    { status: '__wolne__', label: 'wolne' },
                    ...uniqueStatuses
                ];
            }

        },

        mounted: function () {
            if(this.$route.params.chosenLevel) {
                this.scroll({
                    to: '#localList'
                });
            }
           
        },

        watch:{
            $route (to){
                if(to.params.chosenLevel) {
                    this.chosenLevel = levels[to.params.chosenLevel];
                }
            },

        },
        components: {
            //Render: Render,
            //Render1: Render1,
            //Flatplan: Flatplan
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
